import React from "react";

/** Airbnb's share mark (a tray with an arrow up), 16px at stroke 2 in `currentColor`. */
const ShareOutlineIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    viewBox="0 0 32 32"
    aria-hidden
    className={className}
    style={{
      display: "block",
      fill: "none",
      height: 16,
      width: 16,
      stroke: "currentColor",
      strokeWidth: 2,
      overflow: "visible",
    }}
  >
    <path
      fill="none"
      d="m27 18v9c0 1.1046-.8954 2-2 2h-18c-1.10457 0-2-.8954-2-2v-9m11-15v21m-10-11 9.2929-9.29289c.3905-.39053 1.0237-.39053 1.4142 0l9.2929 9.29289"
    />
  </svg>
);

export default ShareOutlineIcon;
